import { Component, OnInit, Inject, ElementRef, ViewChild } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { NotificationService } from '../../_services/notification.service';
import { Router } from '@angular/router';
import { Subscription } from 'rxjs';
import { Http } from '@angular/http';
import { Observable } from 'rxjs/Observable';
import { AngularFirestore } from 'angularfire2/firestore';
import { map } from 'rxjs/operators';
import { __core_private_testing_placeholder__ } from '@angular/core/testing';
import { UserService } from '../../_services/user.service';

@Component({
  selector: 'app-direct-message',
  templateUrl: './direct-message.component.html',
  styleUrls: ['./direct-message.component.css']
})
export class DirectMessageComponent implements OnInit {
  public from: any;
  public to: any;
  ipAddress;
  private subscription = new Subscription;
  @ViewChild("commentText") commentText: ElementRef;
  constructor(
    public dialogRef: MatDialogRef<DirectMessageComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    public notificationService: NotificationService,
    private userSerw: UserService,
    private router: Router,
    private http: Http,
    private afs: AngularFirestore
  ) {

    this.from = data.from;
    this.to = data.to;


  }

  ngOnInit() {
    this.getIpAdress();

    this.subscription = this.afs.collection('users', ref => ref
      .where('username', '==', this.to.username)).snapshotChanges().pipe(map(data => {
        return data.map(user => {
          return {
            id: user.payload.doc.id,
            ...user.payload.doc.data()
          }
        })
      })).subscribe(to => {

        this.to = to[0];



      })


  }

  focus() {
    this.commentText.nativeElement.classList.add("active");
  }

  keyPress(event: KeyboardEvent, text) {

    if (event.keyCode === 13) {
      event.preventDefault();
      this.sendMessage(text);
    }
  }

  getIpAdress() {
    this.subscription.add(this.http.get("https://api.bigadvice.com/helper/ip")
      .map(data => { this.ipAddress = data.json() }).subscribe());
  }

  sendMessage(text) {

    if (!this.from) {
      this.router.navigate(['/auth']);
      this.dialogRef.close();
      return;
    }
    let newText = text.replace(/\s/g, '');
    if (newText == '') {
      return;
    }

    let userMessageKey;

    this.afs.collection('chats').ref.where(this.from.id + '_' + this.to.id, '==', true).get().then((user => {

      let chatKey;
      if (!user.empty) {

        user.forEach(data => {
          chatKey = data.id;
        })

        this.afs.collection('users').doc(this.to.id).collection('myChats').doc(chatKey).set({
          lastMessage: text,
          user: {
            firstname: this.from.firstname,
            lastname: this.from.lastname,
            username: this.from.username,
            profileImage: this.from.profileImage,
            userKey: this.from.id
          },
          modifyDate: Date.now(),
          id: chatKey
        }).then(() => {
          this.afs.collection('users').doc(this.from.id).collection('myChats').doc(chatKey).set({
            lastMessage: text,
            user: {
              firstname: this.to.firstname,
              lastname: this.to.lastname,
              username: this.to.username,
              profileImage: this.to.profileImage,
              userKey: this.to.id
            },
            modifyDate: Date.now(),
            id: chatKey

          })
        }).then(() => {

          this.afs.collection('messages').doc(chatKey).collection('message').add({
            user: {
              firstname: this.from.firstname,
              lastname: this.from.lastname,
              email: this.from.email ? this.from.email : "",
              username: this.from.username,
              profileImage: this.from.profileImage
            },
            message: text,
            modifyDate: Date.now()

          })
        }).then(() => {
          this.userSerw.userLog('send-message', this.ipAddress)
        });

      }


      else {


        this.afs.collection('chats').add({
          [this.from.id + "_" + this.to.id]: true,
          [this.to.id + "_" + this.from.id]: true

        }).then((key) => {
          userMessageKey = key.id;


        }).then(() => {

          this.afs.collection('users').doc(this.to.id).collection('myChats').doc(userMessageKey).set({
            lastMessage: text,
            user: {
              firstname: this.from.firstname,
              lastname: this.from.lastname,
              username: this.from.username,
              profileImage: this.from.profileImage,
              userKey: this.from.id
            },
            modifyDate: Date.now(),
            id: userMessageKey
          })
        }).then(() => {
          this.afs.collection('users').doc(this.from.id).collection('myChats').doc(userMessageKey).set({
            lastMessage: text,
            user: {
              firstname: this.to.firstname,
              lastname: this.to.lastname,
              username: this.to.username,
              profileImage: this.to.profileImage,
              userKey: this.to.id
            },
            modifyDate: Date.now(),
            id: userMessageKey

          })
        }).then(() => {



          this.afs.collection('messages').doc(userMessageKey).collection('message').add({
            user: {
              firstname: this.from.firstname,
              lastname: this.from.lastname,
              email: this.from.email ? this.from.email : "",
              username: this.from.username,
              profileImage: this.from.profileImage
            },
            message: text,
            modifyDate: Date.now()
          }).then(() => {
            this.userSerw.userLog('send-message', this.ipAddress);
          })


        })
      }
      let notification;
      if (userMessageKey) {
        notification = {
          user: {
            firstname: this.from.firstname,
            lastname: this.from.lastname,
            email: this.from.email ? this.from.email : "",
            username: this.from.username,
            profileImage: this.from.profileImage
          },
          id: this.from.id,
          chatKey: userMessageKey,
          title: "Mesaj",
          description: text,
          modifyDate: Date.now(),
          isUnseen: true
        }
      } else {
        notification = {
          user: {
            firstname: this.from.firstname,
            lastname: this.from.lastname,
            email: this.from.email ? this.from.email : "",
            username: this.from.username,
            profileImage: this.from.profileImage
          },
          id: this.from.id,
          chatKey: this.from.id + '_' + this.to.id,
          title: "Mesaj",
          description: text,
          modifyDate: Date.now(),
          isUnseen: true
        }
      }

      this.dialogRef.close();
      this.notificationService.pushMessagesNotification(notification, this.to.id, this.from.id);
      if (userMessageKey) {
        setTimeout(() => {
          this.router.navigate(['/messages'], { queryParams: { message: userMessageKey } });
        }, 1100);
      }
      else {
        setTimeout(() => {
          this.router.navigate(['/messages'], { queryParams: { message: chatKey } });
        }, 1100);

      }


    }))

  }

  public ngOnDestroy(): void {
    this.subscription.unsubscribe();
  }
}



// WEBPACK FOOTER //
// C:/Users/Lenovo/Desktop/bigadvicefirestore/src/app/directive/direct-message/direct-message.component.ts